export default "__VITE_PUBLIC_ASSET__6f5b1683__"